<template>
  <!-- --clr-text: var(--clr-grey-2); -->
  <NavCard
    :hasIcon="false"
    :hasSub="true"
    :class="[
      { trapresitm_open: l_open || active },
      { navcard_active: active },
      { trapresitm_dragged: isDragged },
      { 'gw_loading gw_loading_text': loadingGmf },
    ]"
    class="trapresitm text-noselect"
    style="
      word-break: break-word;
      --padding: 0.5rem 0.5rem 0.5rem 1rem;
      --padding-text: 0;
      --radius: 0;
      --clr-text: var(--clr-white-0);
      --clr-back: var(--clr-black-1-1);
      --clr-back-active: var(--clr-black-1-3);
      --clr-back-hover: var(--clr-black-1-3);
      --padding-title: 0 1rem 0 0;
    "
    @click="handleClick"
  >
    <template #title>
      <div
        v-if="hasDragdrop"
        class="trapresitm_drag-handle cursor-grab mdi mdi-drag-vertical text-semi-large csst csst_nm csst_active-hide-content icon_btn clr-grey"
        @mousedown.stop="startDrag"
        @touchstart.stop="startDrag"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <div
          class="csst_content clr-white text-nowrap"
          style="line-height: 1.2; position: fixed"
          v-html="$t('tooltips.drill_drag_drop_change_order')"
        ></div>
      </div>

      {{ item.name }}
      <i
        v-if="hasTagPremium"
        class="trapresitm_lock mdi mdi-lock text-small ml-1"
        style="color: var(--clr-grey-2)"
      ></i>

      <div
        v-else
        class="trapresitm_star mdi icon_btn csst csst_nm"
        :class="item.favorite ? 'trapresitm_star_active mdi-star' : 'mdi-star-outline'"
        @click.stop="toggleFavorite"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <div
          class="csst_content text-nowrap clr-white"
          style="line-height: 1.2; position: fixed"
        >
          {{ $t(`common.${item.favorite ? 'starred' : 'not_starred'}`) }}
        </div>
      </div>
    </template>
    <template #sub>
      <div class="trapresitm_tags">
        <div
          v-if="item.single_spot"
          class="trapresitm_tag trapresitm_tag_single"
        >
          {{ $t('common.single_spot') }}
        </div>
        <div
          v-if="item.street === 'preflop'"
          class="trapresitm_tag trapresitm_tag_preflop"
        >
          {{ $t('common.preflop') }}
        </div>
        <div
          v-if="item.street === 'postflop'"
          class="trapresitm_tag trapresitm_tag_postflop"
        >
          {{ $t('common.postflop') }}
        </div>
        <div
          v-if="item.is_hard"
          class="trapresitm_tag trapresitm_tag_hard"
        >
          {{ $t('common.hard') }}
        </div>
        <div
          v-if="hasTagPremium"
          class="trapresitm_tag trapresitm_tag_premium"
          @click.stop="$router.push({ name: 'SubscriptionOverview' })"
        >
          <i class="mdi mdi mdi-crown mr-1"></i>
          {{ $t('common.premium') }}
        </div>
      </div>
      <div class="trapresitm_content trainer-preset-item">
        <div>
          {{ item.description }}
        </div>

        <div
          v-if="hasIcons && (l_open || active)"
          class="trapresitm_btns"
        >
          <div
            v-if="customDrill && !canDelete"
            class="csst mdi mdi-delete trapresitm_btn trapresitm_btn_transparent trapresitm_btn_error clr-white"
            @click.stop="canDelete = true"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
          >
            <div
              style="line-height: 1.2; position: fixed"
              class="csst_content trapresitm_btn_tooltip trapresitm_btn_tooltip_right"
              v-html="$t('tooltips.delete_drill')"
            ></div>
          </div>

          <div
            v-if="canDelete"
            class="csst mdi trapresitm_btn trapresitm_btn_transparent mdi-check clr-primary"
            @click.stop="deletePreset"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
          >
            <div
              style="line-height: 1.2; position: fixed"
              class="csst_content trapresitm_btn_tooltip trapresitm_btn_tooltip_right"
              v-html="$t('btn.confirm_delete')"
            ></div>
          </div>

          <div
            v-if="canDelete"
            class="csst csst_nm mdi mdi-close clr-error trapresitm_btn trapresitm_btn_transparent clr-white"
            @click.stop="canDelete = false"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
          >
            <div
              style="line-height: 1.2; position: fixed"
              class="csst_content trapresitm_btn_tooltip trapresitm_btn_tooltip_right"
              v-html="$t('btn.cancel_delete')"
            ></div>
          </div>

          <div
            class="csst mdi mdi-tray-arrow-up trapresitm_btn trapresitm_btn_transparent clr-white tooltip-all-devices"
            @click.stop="
              e => {
                copyToClipboard()
                fl_positionTooltip(e, { placement: 'bottom' })
              }
            "
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
          >
            <div
              class="csst_content trapresitm_btn_tooltip text-wrap"
              :style="
                copied
                  ? `
                  position:fixed
                  width:12rem;
                  background:var(--clr-primary);
                  `
                  : `position:fixed;`
              "
              :class="{ csst_content_visible: copied }"
              v-html="
                copied ? $t('tooltips.drill_copied_to_clipboard') : $t('tooltips.export_drill')
              "
            ></div>
          </div>

          <div
            v-if="!item.public && !loadingNewDrill"
            :class="{ 'no-events': loadingNewDrill }"
            class="csst csst_nm mdi mdi-content-copy trapresitm_btn trapresitm_btn_transparent clr-white"
            @click.stop="cloneDrill"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
          >
            <div
              style="line-height: 1.2; position: fixed"
              class="csst_content trapresitm_btn_tooltip trapresitm_btn_tooltip_right"
              v-html="$t('tooltips.clone_drill')"
            ></div>
          </div>
          <div
            v-if="loadingNewDrill"
            class="trapresitm_btn trapresitm_btn_transparent clr-white"
          >
            <LoaderSpinner style="--size: 1rem" />
          </div>

          <div
            class="csst mdi trapresitm_btn mdi-pencil trapresitm_btn_transparent clr-white"
            @click.stop="
              $emit('configure', {
                dialogProp: customDrill ? 'custompreset' : '',
              })
            "
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
          >
            <!-- :class="!item.public ? 'mdi-pencil' : 'mdi-cog'" -->
            <!-- !item.public
                  ? $t('tooltips.edit_drill')
                  : $t('tooltips.customize_settings') -->
            <div
              style="line-height: 1.2; position: fixed"
              class="csst_content trapresitm_btn_tooltip"
              v-html="$t('tooltips.edit_drill')"
            ></div>
          </div>
          <div
            class="csst mdi mdi-play trapresitm_btn clr-white trapresitm_btn_primary"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
            @click.stop="$emit('startGame')"
          >
            <div
              style="line-height: 1.2; position: fixed"
              class="csst_content trapresitm_btn_tooltip"
              v-html="$t('btn.start_drill')"
            ></div>
          </div>
        </div>
      </div>
    </template>
  </NavCard>
</template>

<script>
import NavCard from '@/components/NavCard/NavCard'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import float_mix from '@/mixins/float_mix'
import { getGameformatGroup } from '@/store/gameformat/gameformat'

export default {
  name: 'TrainerPresetItem',
  components: {
    NavCard,
    LoaderSpinner,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    item: Object,
    active: Boolean,
    isDragged: Boolean,
    selectedPreset: null,
    hasDragdrop: Boolean,

    hasIcons: { type: Boolean, default: true },
  },
  emits: ['configure', 'startGame', 'drag:start', 'click'],
  data() {
    return {
      l_open: false,
      copied: false,
      canDelete: false,
      loadingNewDrill: false,
      loadingGmf: false,
    }
  },
  methods: {
    startDrag(e) {
      if (!this.hasDragdrop) return
      this.$emit('drag:start', e)
    },
    getFavorite(id) {
      return this.$store.getters.favoriteMainDrills.includes(id)
    },
    toggleFavorite() {
      const item = {
        ...this.item,
        favorite: !this.item.favorite,
      }
      this.$store.dispatch('drills_set_drill', {
        namespace: this.namespace,
        items: [item],
        method: 'PATCH',
        hasMessage: false,
        hasExpectedResponse: true,
      })
    },
    deletePreset(item) {
      this.$store.dispatch('drills_set_drill', {
        items: [this.item],
        hasMessage: true,
        method: 'DELETE',
        namespace: this.namespace,
        hasExpectedResponse: true,
      })
    },
    cloneDrill() {
      const items = [
        {
          ...this.item,
          id: '',
          name: `${this.item.name} (copy)`,
        },
      ]
      this.loadingNewDrill = true
      this.$store.dispatch('drills_set_drill', {
        items,
        hasMessage: false,
        method: 'POST',
        hasExpectedResponse: false,
      })
    },
    async handleClick() {
      if (this.active) return
      if (this.loadingGmf) return

      this.l_open = true
      this.canDelete = false

      const mode = getGameformatGroup(this.item.query.gametype)

      if (!this.$store.getters.gameformats_groupsSet[mode]) {
        this.loadingGmf = true
        const result = await this.$store.dispatch('get_gameformat_groups', [mode])
        this.loadingGmf = false
        if (!result || result.error) return
      }

      this.$emit('click', this.item)
    },
    copyToClipboard(bool) {
      this.copied = true
      const res = {
        id: this.item.id,
        query: this.item.query,
        name: this.item.name,
        description: this.item.description,
      }
      const str = JSON.stringify(res)
      navigator.clipboard.writeText(str)
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
  },
  computed: {
    customDrill() {
      return !this.item?.public
    },
    hasTagPremium() {
      return this.item.is_premium && !this.item.gameformat.is_subscribed
    },
  },
  watch: {
    selectedPreset() {
      this.loadingNewDrill = false
      if (this.selectedPreset?.id && !this.active) {
        this.l_open = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.trapresitm {
  --content-height: 0;
  --tag-color: var(--clr-grey-2);
  --drag-handle-opacity: 0;
  border-radius: 4px;
  &_drag-handle {
    opacity: var(--drag-handle-opacity);
    position: absolute;
    left: -1.5rem;
    top: 0;
    padding: 0.125rem;
  }
  &_dragged {
    pointer-events: none;
    opacity: 0.5;
  }
  &_content {
    max-height: var(--content-height);
    display: none;
    &_text {
      font-size: 0.8rem;
      color: var(--clr-grey-2);
    }
  }
  &_star {
    position: absolute;
    right: 0.25rem;
    top: 0;
    font-size: 1.25rem;
    opacity: 0;
    transition: 0.15s;
    padding: 0.125rem;
    color: var(--clr-white-0);
    &_active {
      opacity: 1;
      color: var(--clr-yellow);
    }
  }
  &_lock {
    position: absolute;
    right: 0.25rem;
    top: 0;
    font-size: 1.25rem;
    transition: 0.15s;
    padding: 0.125rem;
    // color: var(--clr-white-0);
  }
  &_tags {
    // display: flex;
    display: none;
    flex-wrap: wrap;
    grid-gap: 0.25rem;
    // padding: 0.5rem 0 0 0;
  }
  &_btns {
    margin-top: 0.25rem;
    display: flex;
    justify-content: flex-end;
    grid-gap: 2px;
  }
  &_tag {
    border-radius: 4px;
    background: var(--clr-black-1);
    font-size: 0.8rem;
    color: white;
    padding: 0 0.25rem;
    margin: 0.25rem 0.25rem 0.25rem 0;
    text-transform: uppercase;
    position: relative;
    overflow: hidden;
    color: var(--tag-color);
    padding: 0 0.25rem 0 0.75rem;
    &:before {
      content: '';
      height: 100%;
      width: 6px;
      position: absolute;
      left: 0;
      top: 0;
    }

    &_single {
      &:before {
        background: var(--clr-yellow);
      }
    }
    &_preflop {
      &:before {
        background: var(--clr-blue);
      }
    }
    &_postflop {
      &:before {
        background: var(--clr-primary);
      }
    }
    &_hard {
      &:before {
        background: var(--clr-error);
      }
    }
    &_premium {
      color: var(--clr-white-0);
      background: var(--clr-primary);
      padding: 0 0.25rem;
    }
  }
  &_btn {
    cursor: pointer;
    font-size: 1.25rem;
    width: 2.25rem;
    height: 2.25rem;
    min-width: 28px;
    min-height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.5rem;
    color: var(--clr-white-0);
    background: var(--clr-black-3);
    --clr-hover: var(--clr-black-4);
    border-radius: 4px;
    &_tooltip {
      color: var(--clr-white-0);
      white-space: nowrap;
    }
    &_transparent {
      background: transparent;
    }
    &_primary {
      --clr-hover: var(--clr-primary);
    }
    &_error {
      --clr-hover: var(--clr-error);
    }
  }
  &_open {
    --content-height: 20rem;
    .trapresitm {
      &_content {
        opacity: 1;
        display: block;
      }
      &_tags {
        display: flex;
      }
      &_tag {
        color: var(--clr-white-0);
      }
      &_star {
        opacity: 1;
      }
    }
  }
}

@media (max-width: 1023px) {
  .trapresitm {
    --drag-handle-opacity: 1;
    &_icon {
      font-size: 1.75rem;
      margin-left: 0.25rem;
    }
    &_tags {
      opacity: 1;
    }
  }
}

@media (hover: hover) and (pointer: fine) {
  .trapresitm {
    &:hover {
      --drag-handle-opacity: 1;
      --tag-color: var(--clr-white-0);
      .trapresitm_tags {
        opacity: 1;
      }
      .trapresitm_star {
        opacity: 1;
      }
    }
    &_btn {
      &:hover {
        background: var(--clr-hover);
      }
    }
  }
}
</style>
